// Notification.js
import React from 'react';
import './Notification.css';

function Notification({ message }) {
  return (
    <div className="notification">
      {message}
    </div>
  );
}

export default Notification;